import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setItemsPerPage,
  setPage,
} from "../Redux/Slice/Common/PaginationSlice";
import { LIMIT_PER_PAGE } from "./Constants";

export const Pagination = (props) => {
  const dispatch = useDispatch();
  const {
    currentPage,
    totalPages,
    previousPage,
    nextPage,
    totalItems,
    itemsPerPage: globalItemsPerPage,
  } = useSelector((state) => state.pagination);
  const itemsPerPage =  props?.itemsPerPage != undefined ? props?.itemsPerPage : globalItemsPerPage; 
  const [localItemsPerPage, setLocalItemsPerPage] = useState(itemsPerPage);

  const [limit, setLimit] = useState(1);
  const [start, setStart] = useState(1);
  const [end, setEnd] = useState(itemsPerPage);
  const [currentList, setCurrentList] = useState(itemsPerPage);
  useEffect(() => {
    if (currentPage === totalPages) {
      if (totalItems < itemsPerPage) {
        setCurrentList(totalItems);
      }
      setStart(currentPage ? (currentPage - 1) * itemsPerPage + 1 : 0);
      setEnd(totalItems ? totalItems : 0);
    } else {
      setStart(currentPage ? (currentPage - 1) * itemsPerPage + 1 : 0);
      setEnd(currentPage ? currentPage * itemsPerPage : 0);
    }
  }, [currentPage, totalPages, totalItems, itemsPerPage]);
  const handleNext = () => {
    if (currentPage < totalPages) {
      setPage(currentPage + 1);
      props.apiMethod(currentPage + 1, itemsPerPage);
      if (currentPage + 1 === totalPages) {
        setCurrentList(totalItems % itemsPerPage);
      } else {
        setCurrentList(itemsPerPage);
      }
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setPage(currentPage - 1);
      props.apiMethod(currentPage - 1, itemsPerPage);
      setCurrentList(itemsPerPage);
    }
  };
  const handleFirst = () => {
    if (currentPage > 1) {
      setPage(1);
      if (1 === totalPages) {
        setCurrentList(totalItems % itemsPerPage);
      } else {
        setCurrentList(itemsPerPage);
      }
      props.apiMethod(1, itemsPerPage);
    }
  };

  const handleLast = () => {
    if (currentPage < totalPages) {
      setPage(totalPages);
      setCurrentList(totalItems % itemsPerPage);
      props.apiMethod(totalPages, itemsPerPage);
    }
  };

  const handleChangeItemsPerPage = (e) => {
    const value = e.target.value;
    if (
      (isNumeric(value) && parseInt(value) > 0 && parseInt(value) <= 500) ||
      value === ""
    ) {
      setLocalItemsPerPage(value);
    }
  };

  const handleGoItemsPerPage = () => {
    if(props?.setItemsPerPage){
      props.setItemsPerPage(localItemsPerPage || LIMIT_PER_PAGE);
    }else{
      dispatch(setItemsPerPage(localItemsPerPage || LIMIT_PER_PAGE));
    }
    if(!localItemsPerPage) setLocalItemsPerPage(LIMIT_PER_PAGE);
    props.apiMethod(1, localItemsPerPage || LIMIT_PER_PAGE);
  };

  const handleGo = () => {
    if (limit <= totalPages && limit > 0) {
      setPage(limit);
      props.apiMethod(limit, itemsPerPage);
      if (limit === totalPages) {
        setCurrentList(totalItems % itemsPerPage);
      } else {
        setCurrentList(itemsPerPage);
      }
    }
  };
  function isNumeric(value) {
    return /^-?\d+$/.test(value);
  }

  const handleLimitChange = (e) => {
    const value = e.target.value;
    if (isNumeric(value) || value === "") {
      setLimit(e.target.value);
    }
  };

  useEffect(() => {
    setLimit(currentPage);
  }, [currentPage]);
  
  useEffect(() => {
    setLocalItemsPerPage(itemsPerPage);
  }, [itemsPerPage]);


  return (
    <div className={"pagination"}>
      <div className="pagination__result">
        {start}-{end} of {totalItems ? totalItems : "0"}{" "}
        {props?.isChatPagination ? "chats" : "items"}
        {!props?.isChatPagination ? (
          <div className="pagination__actions">
            <h6>Items per page:</h6>
            <input
              type="text"
              className="formField__input sm"
              value={localItemsPerPage}
              onChange={handleChangeItemsPerPage}
            />
            <button className="btn btn__primary" onClick={handleGoItemsPerPage}>
              Go
            </button>
          </div>
        ) : null}
      </div>
      <nav
        aria-label="pagination navigation"
        className="MuiPagination-root MuiPagination-outlined css-1oj2twp-MuiPagination-root"
      >
        <ul className="MuiPagination-ul css-wjh20t-MuiPagination-ul">
          <li onClick={handleFirst}>
            <button
              className="MuiButtonBase-root Mui-disabled MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded Mui-disabled MuiPaginationItem-firstLast css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
              tabindex="-1"
              type="button"
              disabled={currentPage < 2}
              aria-label="Go to first page"
            >
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.83333 11.3332L4.5 7.99984L7.83333 4.6665M12.5 11.3332L9.16667 7.99984L12.5 4.6665"
                  stroke="#150823"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
          </li>
          <li onClick={handlePrevious}>
            <button
              className="MuiButtonBase-root Mui-disabled MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded Mui-disabled MuiPaginationItem-previousNext css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
              tabindex="-1"
              type="button"
              disabled={currentPage < 2}
              aria-label="Go to previous page"
            >
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.5 12L6.5 8L10.5 4"
                  stroke="#150823"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </button>
          </li>
          {previousPage && !nextPage ? (
            <li onClick={handlePrevious}>
              <button
                className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded MuiPaginationItem-page css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
                tabindex="0"
                type="button"
                aria-label="Go to page 2"
              >
                {previousPage}
                <span className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
              </button>
            </li>
          ) : (
            ""
          )}
          {currentPage ? (
            <li>
              <button
                className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded Mui-selected MuiPaginationItem-page css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
                tabindex="0"
                type="button"
                aria-current="true"
                aria-label="page 1"
              >
                {currentPage}
                <span className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
              </button>
            </li>
          ) : null}
          {nextPage ? (
            <li onClick={handleNext}>
              <button
                className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded MuiPaginationItem-page css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
                tabindex="0"
                type="button"
                aria-label="Go to page 2"
              >
                {nextPage}
                <span className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
              </button>
            </li>
          ) : (
            ""
          )}
          <li onClick={handleNext}>
            <button
              className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded MuiPaginationItem-previousNext css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
              tabindex="0"
              type="button"
              disabled={currentPage === totalPages}
              aria-label="Go to next page"
            >
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.5 12L10.5 8L6.5 4"
                  stroke="#150823"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
              <span className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
            </button>
          </li>
          <li onClick={handleLast}>
            <button
              className="MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-sizeMedium MuiPaginationItem-outlined MuiPaginationItem-rounded MuiPaginationItem-firstLast css-19xm0h7-MuiButtonBase-root-MuiPaginationItem-root"
              tabindex="0"
              type="button"
              disabled={currentPage === totalPages}
              aria-label="Go to last page"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.66667 11.3332L12 7.99984L8.66667 4.6665M4 11.3332L7.33333 7.99984L4 4.6665"
                  stroke="#150823"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
              <span className="MuiTouchRipple-root css-8je8zh-MuiTouchRipple-root"></span>
            </button>
          </li>
        </ul>
      </nav>
      {!props?.isChatPagination ? (
        <div className="pagination__actions">
          <h6>Go to page</h6>
          <input
            type="text"
            className="formField__input sm"
            value={limit}
            onChange={handleLimitChange}
          />
          <button className="btn btn__primary" onClick={handleGo}>
            Go
          </button>
        </div>
      ) : (
        <div className="pagination__actions" />
      )}
    </div>
  );
};
